export default __webpack_public_path__ + "static/media/arrowRight.e1af3f68.svg";